import { ProviderItemInputs } from './provider-item-inputs';

export class ProviderValidation {
    public items: ProviderItemInputs[];
    public errors: ProviderItemInputs[];
    public valid: boolean;
    constructor(items: ProviderItemInputs[], errors: ProviderItemInputs[]) {
        this.items = items;
        this.errors = errors;
        this.valid = errors.length > 0 ? false : true;
    }
}